// eslint-disable-next-line no-shadow
export enum ApiStage {
	IDLE = 'idle',
	LOADING = 'loading',
	SUCCESS = 'success',
	FAILED = 'failed',
	ERROR = 'error',
	STAND_BY = 'stand_by',
	READY = 'ready',
}
